import React from 'react';
import PublicStaticPage from './PublicStaticPage';

const Documentation = () => <PublicStaticPage pageKey="docs" />;

export default Documentation;
